import React, { MouseEvent, memo } from 'react'
import { SortArrowToggle } from 'transfix-ui/components/SortArrowToggle'
import { DeactivatedDriverToolTip } from 'apps/fleet-planner/components/drivers/DeactivatedDriverTooltip'
import { IUseDriverParamsState } from 'apps/fleet-planner/hooks/useDriverParams'
import { SortFieldType } from 'apps/fleet-planner/types/hooks'
import { TableHead, TableRow, TableCell } from 'transfix-ui'

interface IDriversTableHeader {
  params: IUseDriverParamsState
  onChange: (sortField: SortFieldType) => void
}

export const DriversTableHeader = memo<IDriversTableHeader>(({ onChange, params }) => {
  const sortHandler = (e: MouseEvent<HTMLButtonElement>) =>
    onChange(e.currentTarget.value as SortFieldType)
  return (
    <TableHead>
      <TableRow tableCellType='th'>
        <TableCell className='pl6' dataTest='status-column-header'>
          Status
          <DeactivatedDriverToolTip isDriversPage className='ml4' />
        </TableCell>
        <TableCell className='pl6' dataTest='driver-name-column-header'>
          <button className='sort' value='name' onClick={sortHandler}>
            Driver Name{' '}
            <SortArrowToggle
              direction={params.sortField === 'name' ? params.sortOrder : undefined}
            />
          </button>
        </TableCell>
        <TableCell dataTest='carrier-column-header'>
          <button className='sort' value='motor_carrier_legal_name' onClick={sortHandler}>
            Carrier{' '}
            <SortArrowToggle
              direction={
                params.sortField === 'motor_carrier_legal_name' ? params.sortOrder : undefined
              }
            />
          </button>
        </TableCell>
        <TableCell dataTest='cellphone-column-header'>Cellphone</TableCell>
        <TableCell dataTest='email-column-header'>Email</TableCell>
        <TableCell dataTest='updated-column-header'>
          <button className='sort' value='updated_at' onClick={sortHandler}>
            Last Modified{' '}
            <SortArrowToggle
              direction={params.sortField === 'updated_at' ? params.sortOrder : undefined}
            />
          </button>
        </TableCell>
      </TableRow>
    </TableHead>
  )
})
